import { render, staticRenderFns } from "./health-check.vue?vue&type=template&id=426aef6c&"
import script from "./health-check.vue?vue&type=script&lang=js&"
export * from "./health-check.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports